import React from 'react';

import { logout } from 'src/services/session';

const onLogoutClick = e => {
  e.preventDefault();
  logout();
};

const LogoutLink = ({ children }) => (
  <a href="# " onClick={onLogoutClick}>{children}</a>
);

export default LogoutLink;
